// File: src/layouts/MainLayout.vue
<template>
    <!-- Global Screen Reader Announcer for Accessibility -->
    <div id="sr-announcer" aria-live="polite" aria-atomic="true" class="visually-hidden"></div>

    <AppSidebar />
    <main>
        <MainNavbar />

        <div id="content-wrapper" class="d-flex flex-column">
            <div class="content py-5">
                <div class="bg-body-secondary rounded shadow w-90 mx-auto p-4">
                    <slot></slot>
                </div>
            </div>
            <footer class="copyright w-full small text-center border-t border-grey p-4 pin-b">
                &copy; 2023 &mdash; 2024 <strong>Cirrus Invicta</strong>&trade;. All rights
                reserved.
                <div>
                    <small>
                        Version: {{ appVersion }} (Build: {{ buildNumber }})
                        <span v-if="apiVersion"> [API Version: {{ apiVersion }}]</span>
                    </small>
                </div>
            </footer>
        </div>
    </main>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import AppSidebar from '../components/AppSidebar.vue'
import MainNavbar from '../components/MainNavbar.vue'
import { getApiVersion } from '@/services/VersionService'

// const components = { AppSidebar, Navbar }

const appVersion = import.meta.env.VITE_APP_VERSION
const buildNumber = import.meta.env.VITE_BUILD_NUMBER
const apiVersion = ref(null)

onMounted(async () => {
    try {
        const versionData = await getApiVersion()
        apiVersion.value = versionData?.version?.version || null
    } catch (error) {
        // Silently fail - API version is optional information
        console.error('Could not fetch API version:', error)
    }
})
</script>

<style scoped>
/* Any styles common to all main layout pages */
</style>
